import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined,SaveOutlined,DeleteOutlined} from "@ant-design/icons";
import {seasonMonths} from "../../../../../../components/functions/Month";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {add_func} from "../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import swal from "sweetalert";
import { getEnv } from "../../../../../../lib/env";
function Add() {
    if(!user_data() || user_data().region_id != 16){
        window.location = '/limit/daryolar/sirdaryo'
    }
    const [hasData, setHasData] = useState(0)
    const [year, setYear] = useState('')
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const [data, setData] = useState()
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitdaryo/dekada?year="+year+"&season="+season+"&daryo=sir", header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
                setHasData(res.data.hasData)
            }
        }
        if(year){
            fetchData()
        }
    },[year,season])
    const add = (arr,r,c) => {
        let l = 0;
        r.map(i=>{
            if(arr[i]){
                l = add_func(l,arr[i][c])
            }
            return null;
        })
        return l;
    }
    const setHandler = (i,d,v) => {
        let dat = {...data}
        if(dat[i]){
            dat[i][d] = v
            setChanged(true)
        }
        if(dat[1]){dat[1][d] = add(dat,[2,3],d)}
        if(dat[6]){dat[6][d] = add(dat,[7,8,9],d)}
        if(dat[10]){dat[10][d] = add(dat,[11,12,13],d)}
        if(dat[14]){dat[14][d] = add(dat,[1,4,5,6],d)}
        if(dat[18]){dat[18][d] = add(dat,[15,16,17],d)}
        if(dat[21]){dat[21][d] = add(dat,[22,23],d)}
        if(dat[24]){dat[24][d] = add(dat,[25,26],d)}
        if(dat[27]){dat[27][d] = add(dat,[28,29],d)}
        if(dat[30]){dat[30][d] = add(dat,[19,20,21,24,27],d)}
        if(dat[31]){dat[31][d] = add(dat,[14,18,30],d)}
        if(dat[32]){dat[32][d] = dat[7][d]}
        if(dat[33]){dat[33][d] = add(dat,[8,17],d)}
        if(dat[34]){dat[34][d] = add(dat,[3,4,5,9,15,16],d)}
        if(dat[35]){dat[35][d] = add(dat,[19,20,25,29],d)}
        if(dat[36]){dat[36][d] = add(dat,[22,26,28],d)}
        if(dat[37]){dat[37][d] = dat[23][d]}
        setData(dat)
    }
    console.log(data)
    const [changed, setChanged] = useState(false)
    const doIt = async (action) => {
        const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitdaryo/"+action,{data,year,season}, header())
            .catch(e=>{
                console.log("Xato",e)
                alert("Server bilan aloqa yo'q!")
            })
        if(res){
            if(res.data.status == 200){
                swal("Muvaffaqiyalti", res.data.message, 'success')
                window.location = "/limit/daryolar/sirdaryo"
            }else{
                swal("Xato", res.data.message, 'error')
            }
        }
    }
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left d-flex align-items-center">
                    <NavLink to="/limit/daryolar/sirdaryo" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                        <ArrowLeftOutlined />&nbsp;&nbsp;&nbsp;Qaytish
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;
                    {
                        changed ? <button className="btn btn-sm btn-outline-primary d-flex align-items-center" onClick={()=>doIt('save')}>
                            Saqlash &nbsp;&nbsp;&nbsp;<SaveOutlined />
                        </button> :null
                    }
                    {
                        hasData ? <button className="btn btn-sm btn-outline-danger d-flex align-items-center" onClick={()=>doIt('delete')}>
                            O'chirish &nbsp;&nbsp;&nbsp;<DeleteOutlined />
                        </button> :null
                    }

                </div>
                <ul className="table-top-right">

                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>

                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <table className="table table-bordered table-style">
                    <thead>
                    <tr>
                        <th colSpan={20}>O‘zbekiston Respublikasi bo‘yicha {year}-yilning {season == 'noveg' ? 'no' :null}sug‘orish mavsumiga Norin - Sirdaryo o‘zani bo‘yicha suv olish limiti</th>
                    </tr>
                    <tr>
                        <th rowSpan={2} scope="col" style={{width:'20px'}}>№</th>
                        <th rowSpan={2} scope="col" style={{width:'200px'}}>Kanallar, ITXB va viloyatlar nomi</th>
                        {
                            seasonMonths(season).map((s,i)=>{
                                return <th key={i} colSpan={3}>{s}</th>
                            })
                        }
                    </tr>
                    <tr>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                    </tr>
                    </thead>
                    {
                        data&&Object.keys(data).length>0?
                            Object.keys(data).map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th scope="col" style={{width:'20px'}}>{i+1}</th>
                                    <th scope="col" style={{width:'200px'}}>{data[d]?data[d].name:''}</th>
                                    {
                                        Array(18).fill().map((p,ind)=>{
                                            return <th scope="col" key={ind} className="inserttr">
                                                <input
                                                    type="number"
                                                    className="insertable"
                                                    value={data[d]?data[d]['d'+(ind+1)]?data[d]['d'+(ind+1)]:'':''}
                                                    onChange={e=>setHandler(d,'d'+(ind+1),e.target.value)}
                                                    readOnly={['1','6','10','14','18','21','24','27','30','31','32','33','34','35','36','37'].includes(d)}
                                                />
                                            </th>
                                        })
                                    }
                                </tr>
                                </tbody>
                            })
                            :null
                    }
                </table>
            </div>
        </>
    );
}

export default Add;

